import Button from '@atlaskit/button';
import React from 'react';

import { SLACK_HELP_CHANNEL_LINK } from '@/constants';

import CustomIcon from '../icon';

import { buttonIconStyles } from './styles';

const FeedbackLink = () => (
  <Button
    href={SLACK_HELP_CHANNEL_LINK}
    target="_blank"
    iconBefore={
      <span css={buttonIconStyles}>
        <CustomIcon src="/static/slack.svg" isMini />
      </span>
    }
  >
    Give Feedback
  </Button>
);

export default FeedbackLink;
